const TRHeader = ({ children }) => {
  return (
    <thead>
      <tr className="bg-gray-50">{children}</tr>
    </thead>
  );
};

export default TRHeader;
